import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { getApi } from '../../../../../../../api/api'
import { setCurrentCluster } from '../../../../../../../store/slices/currentClusterSlice'


export const useSalesSection = () => {
  const [modalActive, setModalActive] = useState(false)

  const dispatch = useDispatch()
  const [api] = useState(getApi())
  const [loading, setLoading] = useState<boolean>(false)

  const getClusters = useCallback(async () => {
    try {
      const result = await api.getClusterList()
      if (result?.data.length) {
        if (result.data[0].port && result.data[0].token) {
          localStorage.setItem('currentCluster', JSON.stringify(result.data[0]))
          dispatch(setCurrentCluster(result.data[0]))
        }
      }
    } catch (error) {}
  }, [api, dispatch])


  return {
    modalActive,
    setModalActive,

    getClusters,
    loading,
    setLoading,
  }
}
